await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/item-selector-taglib/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React from 'react';

export default function dragFileIcon() {
	return (
		<svg
			className="dropzone-drag-file-icon"
			height="64"
			viewBox="0 0 55 43"
			width="86"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20,33h-3.8v-1.9H20V33z M12.4,33H8.7v-1.9h3.8V33z M4.9,33H3.8c-1.2,0-2.4-0.6-3.1-1.6l1.5-1.1 c0.4,0.5,0.9,0.8,1.5,0.8h1.1V33z M1.9,27.2H0v-3.8h1.9V27.2z M44,19.7h-1.9V16H44V19.7z M1.9,19.6H0v-3.8h1.9V19.6z M44,12.2h-1.9 V8.4H44V12.2z M1.9,12H0V8.2h1.9V12z M44,4.6h-1.9V3.8c0-0.7-0.4-1.3-1-1.6l0.9-1.6C43.3,1.2,44,2.4,44,3.8V4.6z M1.9,4.4H0V3.8 c0-1.4,0.8-2.7,2.1-3.4l0.9,1.7c-0.6,0.3-1,1-1,1.7V4.4z M37.9,1.9h-3.8V0h3.8V1.9z M30.3,1.9h-3.8V0h3.8V1.9z M22.7,1.9h-3.8V0h3.8 V1.9z M15.2,1.9h-3.8V0h3.8V1.9z M7.6,1.9H3.8V0h3.8V1.9z"
				fill="#a7a9bc"
			/>

			<path
				d="M16.7,8.6h-2.9c-0.5,0-0.9,0.4-0.9,0.9v2.9c0.1,1.3,1.8,1.2,1.9,0v-0.7l4.9,4.9c0.9,0.9,2.2-0.4,1.3-1.3 l-4.9-4.9h0.7C18,10.4,18,8.6,16.7,8.6z"
				fill="#6b6c7e"
			/>

			<path
				d="M26.5,18.1H51c2.1,0,3.8,1.7,3.8,3.8v16.4c0,2.1-1.7,3.8-3.8,3.8H26.5c-2.1,0-3.8-1.7-3.8-3.8V21.9 C22.7,19.8,24.4,18.1,26.5,18.1z"
				fill="#6b6c7e"
			/>
		</svg>
	);
}
